// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_GROUPS = "Skupiny";
export const TAB_FORUMS = "F\u00f3ra";
export const TAB_GROUPS = "Skupiny";
